/**
 * ENNAME-4 · 产品英文名「必填 + 字符检测」的前端共享规则。
 *
 * 🔴 这是后端 `services/product_names.py::real_english` 的逐字翻译，不是另一套规则——规则只有一份：
 *   空 / 只有空白、等于中文名、含中日韩文字（中文 / 日文假名 / 韩文 / 全角符号）、不含任何拉丁字母 → 不合格。
 * 两边用同一张用例表（apps/api-server/tests/fixtures/enname4_cases.json）对拍，改一边必须改另一边。
 * 不用 AI，只做字符检测。
 */

const CJK_RE = /[　-〿぀-ヿ가-힯㐀-䶿一-鿿豈-﫿＀-￯]/;   // 同后端 _CJK_RE（含日文假名 / 韩文）
const LATIN_RE = /[A-Za-zÀ-ɏ]/;                                                                 // 同后端 _LATIN_RE

export const EN_NAME_REQUIRED_MSG = "英文名不能为空、不能含中文、要有英文字母，也不能和中文名一样";
/** 输入框下的固定提示 / 红字正文（带示例）。 */
export const EN_NAME_HELP = "英文名不能含中文，请填写英文（可以带编号，如 SEA14-C1 Seattle City Day Tour）";
/** 旧数据：库里存的是中文（旧向导把中文名复制进英文名），编辑态输入框显示为空 + 这句红字。 */
export const EN_NAME_LEGACY_MSG = "原来存的是中文，请重填英文名";

/** 合格 → 去掉首尾空白的英文名；不合格 → null。 */
export function realEnglish(nameEn: string | null | undefined, nameCn: string | null | undefined): string | null {
  const en = (nameEn ?? "").trim();
  if (!en) return null;
  if (en === (nameCn ?? "").trim()) return null;
  if (CJK_RE.test(en)) return null;
  if (!LATIN_RE.test(en)) return null;
  return en;
}

/** 不合格 → 人话提示；合格 → null。 */
export function englishNameError(nameEn: string | null | undefined, nameCn: string | null | undefined): string | null {
  return realEnglish(nameEn, nameCn) === null ? EN_NAME_REQUIRED_MSG : null;
}

/** 编辑回填：库里存的值合格就原样显示；不合格（中文顶替等）→ 显示为空，并告诉调用方「这是旧数据」（要亮红字）。 */
export function prefillEnglishName(stored: string | null | undefined, nameCn: string | null | undefined): { value: string; legacy: boolean } {
  const ok = realEnglish(stored, nameCn);
  if (ok !== null) return { value: stored!.trim(), legacy: false };
  return { value: "", legacy: !!(stored ?? "").trim() };
}
